import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'arrayByLength',
  standalone: true
})
export class ArrayByLengthPipe implements PipeTransform {

  public transform(length: number, startFromZero?: boolean): number[] {
    return [].generateArrayByLength(length, startFromZero);
  }
}
